import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { Logo } from "./Logo";

const slug = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, "-");

const NavItem = ({ item, mobile }) => (
  <NavLink to={item.path} end={item.path === "/"} data-testid={`nav-${mobile ? "mobile-" : ""}${slug(item.label)}-link`}
    className={({ isActive }) => `${mobile ? "block px-2 py-3 text-lg" : "relative py-2 text-[15px]"} transition-colors duration-200 hover:text-gold ${
      isActive ? "text-gold font-semibold" + (mobile ? "" : " after:absolute after:-bottom-0.5 after:left-0 after:h-0.5 after:w-full after:bg-ciarb") : "text-white/90"}`}>
    {item.label}
  </NavLink>
);

export default function Header() {
  const { navigation } = useSite();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const items = (navigation?.items || []).filter((i) => i.visible);

  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // Black header so the supplied logo (JPEG on black) sits seamlessly.
  return (
    <header className="on-dark sticky top-0 z-40 border-b-2 border-gold bg-black" data-testid="site-header">
      <div className="container-site flex h-20 items-center justify-between gap-6">
        <Link to="/" data-testid="header-home-logo-link" aria-label="CIArb Bahamas Branch home"><Logo plate={false} /></Link>
        <nav aria-label="Main" className="hidden items-center gap-6 xl:flex">
          {items.map((i) => <NavItem key={i.path} item={i} />)}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/registration" className="btn-primary btn-sm hidden sm:inline-flex" data-testid="header-register-now-btn">Register Now</Link>
          <button type="button" className="rounded p-2 text-white xl:hidden" aria-expanded={open} aria-controls="mobile-nav"
            aria-label={open ? "Close menu" : "Open menu"} onClick={() => setOpen((o) => !o)} data-testid="mobile-menu-toggle">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>
      {open && (
        <nav id="mobile-nav" aria-label="Mobile" className="border-t border-white/15 bg-black xl:hidden" data-testid="mobile-nav">
          <div className="container-site py-3">
            {items.map((i) => <NavItem key={i.path} item={i} mobile />)}
            <Link to="/registration" className="btn-primary mt-3 w-full sm:hidden" data-testid="mobile-register-now-btn">Register Now</Link>
          </div>
        </nav>
      )}
    </header>
  );
}
